import { NavBar } from 'components'
import React from 'react'

const SideNavBarLayout = () => (
    <NavBar />
)

export default SideNavBarLayout
